import { api } from '@/global/services/api'
import { isObject } from '@/global/utils/utils'
import editTabsMixin from '../../mixins/editTabsMixin'

const TAB_KEY = 'userRoles'

export default {
  mixins: [
    editTabsMixin
  ],

  data () {
    return {
      userRolesKey: TAB_KEY,
      roleAutocompletesItems: {},
      roleAutocompleteOptions: [],
      showUserRolesTabLoader: false,
      userRolesPermissions: {}
    }
  },

  computed: {
    userRolesEditConfig () {
      return {
        title: this.$t('base/user.roles'),
        key: TAB_KEY,
        onLoad: () => this.onUserRolesTabLoad(),
        visible: this.showUserRolesTab,
        apiConfig: {
          get: {
            module: 'base',
            route: `user/${this.$route.params.id}/roles`
          },
          post: {
            module: 'base',
            route: `user/${this.$route.params.id}/roles`
          }
        },
        dataFetched: (event) => {
          const { meta } = event?.data || {}
          this.userRolesPermissions = meta?.permissions
          this.roleAutocompleteOptions = meta?.autocomplete_options || []
        },
        modifyDataBeforeSend: (event) => this.modifyUserRolesDataBeforeSend(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base/user.roles'),
            showBackButton: {
              onGoBack: () => this.goBack()
            }
          },
          {
            component: this.columnsContentComponent,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: this.roleFields
              }
            ]
          }
        ]
      }
    },

    roleFields () {
      return this.roleAutocompleteOptions.map(option => ({
        key: `${option.module}_role_id`,
        label: option.label,
        type: 'combobox',
        items: this.roleAutocompletesItems?.[option.module] || [],
        autocomplete_options: {
          custom_display_value: (event) => event?.display_name || '',
          allowCustomValue: false
        },
        creatable: true,
        editable: true,
        visible: option.allowed
      }))
    }
  },

  methods: {
    async onUserRolesTabLoad () {
      try {
        this.showUserRolesTabLoader = true
        const { data } = await api('base').get('role/auth-user-descendant-roles')
        if (data && isObject(data)) {
          this.roleAutocompletesItems = data
        }
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showUserRolesTabLoader = false
      }
    },

    modifyUserRolesDataBeforeSend (event) {
      const { copiedData } = event || {}

      for (const option of this.roleAutocompleteOptions) {
        const key = `${option.module}_role_id`
        if (copiedData?.[key]?.length) {
          copiedData[key] = copiedData[key].map(role => (role && typeof role === 'object') ? role.id : role).filter(Boolean)
        }
        else {
          delete copiedData[key]
        }
      }

      return copiedData
    }
  }
}
